import { useQuery } from "@tanstack/react-query";
import { useCurrentPulseInstance } from "./pulseInstanceHooks";
import { ProductInstanceQueryOptions } from "@pulse/api/queryApi";
import { useMemo } from "react";

export function useCurrentCustomerId(): number | null {
    const { data: instance } = useCurrentPulseInstance();
    const { data: productInstances } = useQuery(ProductInstanceQueryOptions());
    const customerId = useMemo(
        () =>
            productInstances?.find((pi) => pi.id === instance?.productInstanceId)?.customerId ||
            null,
        [productInstances, instance],
    );

    return customerId;
}
